<div class="my-dashboard-container" cdkScrollable>
    <dashboard-header-component
        [userName]="userName"
        [teams]="teams"
        [teamId]="teamId"
        [clientId]="clientId"
        [isSupervisorDashboardEnabled]="isSupervisorDashboardEnabled"
        [accounts]="accounts"
        [accountFilter]="accountFilter"
        [isAccountFilterEnabled]="isAccountFilterEnabled"
        (teamValueEmitted)="handleTeamValueEmitted($event)"
        (accountValueEmitted)="handleAccountValueEmitted($event)">
    </dashboard-header-component>
    <div class="dashboard-content">
        <ng-container *ngIf="teamId === 'my-dashboard'">
            <ng-container *ngIf="clientId">
                <dashboard-cases-component [clientId]="clientId"></dashboard-cases-component>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="teamId !== 'my-dashboard'">
            <team-dashboard-component
                [team]="getTeamById(teamId)"
                [accountFilter]="accountFilter"
                [rawPerformanceData]="rawPerformanceData"
                [rawTeamDashboardData]="rawTeamDashboardData"
                [teamTasksEnabled]="teamTasksEnabled">
            </team-dashboard-component>
        </ng-container>
    </div>
</div>